export default __webpack_public_path__ + "static/media/show3.7d33a2f3.jpeg";